import filigrane from '@assets/svg/filigrane.svg'
import { Container } from '@ui/container'
import React, { type FC, type PropsWithChildren } from 'react'

const SectionTemplateFiligraneRight: FC<PropsWithChildren> = ({ children }) => (
  <div className="mb-10 mt-2.5 flex h-full w-full justify-center">
    <Container
      className="mx-0 max-w-none rounded-[16px] border-none bg-grey-50 bg-[length:250%] bg-[right_-80vw_top_-50vw] bg-no-repeat py-10 laptop:mx-3 laptop:border laptop:border-solid laptop:border-grey-100 laptop:bg-[length:150%] laptop:bg-[right_-40vw_top_-50vw]"
      style={{ backgroundImage: `url(${filigrane})` }}
    >
      {children}
    </Container>
  </div>
)

export default SectionTemplateFiligraneRight
